<template>
  <div id="app">
    <PrimaryContact />
  </div>
</template>

<script>
import PrimaryContact from './components/PrimaryContact.vue'

export default {
  name: 'App',
  components: {
    PrimaryContact
  },
  mounted: function() {
    const that = this;
    const appEll = document.querySelector('#app');
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.contentRect) {
          that.changeDimensions(entry.contentRect.height)
        }
      }
    });
    resizeObserver.observe(appEll);
    this.changeDimensions(appEll.offsetHeight);
  },
  methods: {
    changeDimensions(appEl) {
      this.$store.state.appHeight = appEl;
      window.parent.postMessage({ iframeHeight: appEl });
    }
  },
  watch: {}
}
</script>

<style>
@import './assets/css/main.css';
</style>
